module.exports = __webpack_public_path__ + "static/media/xbox.c1b35e89.svg";